import { motion } from "framer-motion";
import React from "react";

export default function AnimatedText({ text }) {
  return (
    <div
      className="position-relative d-inline-flex justify-content-center align-items-center"
      style={{ textWrap: "nowrap", textAlign: "center" }}
    >
      {/* Background Text (faint, behind, large) */}
      <motion.span
        initial={{ opacity: 0.15 }}
        whileHover={{ opacity: 0.4 }}
        className="text-uppercase fw-bold text-primary  fs-md-1 user-select-none"
        style={{
          position: "absolute",
          zIndex: 1,
          pointerEvents: "none",
          whiteSpace: "nowrap",
          display: "block",
          textAlign: "center",
        }}
      >
        {text}
      </motion.span>

      {/* Foreground Text (normal, animated on hover) */}
      <motion.span
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        transition={{ type: "spring", stiffness: 250 }}
        className="text-uppercase fs-1  fs-md-4 fs-lg-2 fw-bold text-primary"

        style={{
          zIndex: 2,
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {text}
      </motion.span>
    </div>
  );
}
